import { put, call, fork, all, select, takeLatest } from "redux-saga/effects";
import moment from 'moment-timezone';
import { connect, Connect } from "react-redux";
import { withRouter } from 'react-router';
import { instanceOf } from "prop-types";
import * as queryString from 'query-string';
import * as IDTypes from "../constants/PatientIDTypes";
import * as React from "react";

const CENTRAL_TIME_ZONE = "America/Chicago";


export const hpAPIBaseURL = () => {
    var oState = window.store.getState();

    if (window.location.href.toLocaleLowerCase().includes("localhost")) {
        if (oState.domain.pre == "HR") {
            var hpServicesSpecificUrl = buildUrl(window.serverData.data.hpServicesUrl, "");
            return hpServicesSpecificUrl;
        }
    }

    var sRet = ciReplace(window.serverData.data.hpGatewayUrl, "WTPA", oState.domain.pre);
    return sRet;
};

export const hrAPIBaseURL = () => {
    var prefix = "HR";

    if (window.location.href.toLocaleLowerCase().includes("localhost")) {
        var hpServicesSpecificUrl = buildUrl(window.serverData.data.hpServicesUrl, "");
        return hpServicesSpecificUrl;
    }

    var sRet = ciReplace(window.serverData.data.hpGatewayUrl, "WTPA", prefix);
    return sRet;
};


export const ciReplace = (sStringToReplaceIn, sStringToReplace, sStringToReplaceWith) => {
    var regEx = new RegExp(sStringToReplace, "ig");
    //debugger;
    return sStringToReplaceIn.replace(regEx, sStringToReplaceWith);
}



export const getURLPath = (serverURL = null) => {
    //debugger;
    if (typeof window !== 'undefined') {
        //debugger;
        return window.location.pathname;
    }
    else {
        //debugger;
        return serverURL;
    }
};


export const getMyChartCookieName = () => {
    var sName = 'BSWSSO';
    if (window.serverData.data.environment.toLowerCase() == "prod") {
        return sName;
    }
    sName += "-" + window.serverData.data.environment;
    return sName;
}

export const getDomain = (serverURL) => {
    var sRet = "";
    var iDot = 0;
    if (typeof window !== "undefined") {
        sRet = window.location.hostname;
        iDot = sRet.indexOf(".");
        if (iDot > 0) {
            sRet = sRet.substring(iDot + 1);
        }
        return sRet;
    }
    else {
        if (serverURL) {
            //console.log("getDomain staritng with: " + serverURL);
            var iStart = serverURL.indexOf("//");
            //console.log("getDomain iStart = " + iStart);
            var iEnd = serverURL.indexOf("/", iStart + 2);
            var iEnd2 = serverURL.indexOf(":", iStart + 2);
            if (iEnd2 > 0) {
                if (iEnd2 < iEnd) {
                    iEnd = iEnd2;
                }
            }
            if (iEnd < 1) {
                iEnd = serverURL.length + 1;
            }
            //console.log("getDomain iEnd = " + iEnd);
            sRet = serverURL.substring(iStart + 2, iEnd);
            //console.log("getDomain parsed = " + sRet + "  Parsed length = " + sRet.length);
            iDot = sRet.indexOf(".");
            if (iDot > 0) {
                sRet = sRet.substring(iDot + 1);
            }
            return sRet;
        }
    }
};

export const splitIntoRowsOf = (arrayObj, iMaxPerRow) => {
    if (arrayObj === null || typeof arrayObj === "undefined") { return null; }
    //debugger;
    try {
        var newArray = [];
        //debugger;
        for (var i = 0; i < arrayObj.length; i = i + iMaxPerRow) {
            //debugger;
            newArray.push(arrayObj.slice(i, i + iMaxPerRow));
            //debugger;
        }
        return newArray;
    }
    catch (ex) {
        //debugger;
        return arrayObj;
    }
};


export const mergeArrays = (array1, array2) => {
    if (typeof array1 === "undefined") { array1 = []; }
    if (typeof array2 === "undefined") { array2 = []; }
    var ret = array1.concat(array2.filter(function (item) { return array1.indexOf(item) < 0; }));
    return ret;
};

export const getUnhydratedProviderNPIs = (arrayNPI, arrayHydratedProviders) => {
    //debugger;
    if (typeof arrayNPI === "undefined") { arrayNPI = []; }
    if (typeof arrayHydratedProviders === "undefined") { arrayHydratedProviders = []; }
    var ret = arrayNPI.filter(function (item) { return typeof arrayHydratedProviders.find(function (prov) { return prov.npi === item; }) === "undefined"; });
    if (ret.length > 0) {
        //debugger;
    }
    return ret;
};

export const getFormattedDate = (date) => {
    if (!isValidDate(date)) { return null; }
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return month + '/' + day + '/' + year;
};

export const isAndroid = () => {
    if (typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent)) {
        return true;
    }
    return false;
};

export const isIos = () => {
    if (typeof navigator !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent))
        return true;
    return false;
};

export const isIPad = () => {
    if (typeof navigator !== 'undefined' && /iPad/i.test(navigator.userAgent))
        return true;
    return false;
};


export const isMobile = () => {
    return isAndroid() || isIos() || isIPad();
}


export const isValidZipCode = (zipCode) => {
    try {
        zipCode = zipCode || "";
        const regex = /^\d{1,5}$/; //ZipCode is 5 digit long and only number
        return regex.test(zipCode) && zipCode.length === 5;
    }
    catch (e) {
        return false;
    }
};

export const isValidDate = (thisDate) => {
    try {
        if (typeof thisDate === "string") {
            const workDate = new Date(thisDate);
            return (typeof thisDate !== "undefined") && (thisDate !== null) && (thisDate !== "") && (!isNaN(workDate.valueOf()));
        }
        else {
            return (typeof thisDate !== "undefined") && (thisDate !== null) && (thisDate !== "") && (!isNaN(thisDate.valueOf()));
        }
    }
    catch (e) {
        return false;
    }
};

export const isFutureDate = (thisDate) => {
    try {
        const dateValue = new Date(thisDate);
        var currentDate = new Date();
        return isValidDate(thisDate) && dateValue > currentDate;
    }
    catch (e) {
        return false;
    }
};

export const isEmptyString = (thisString) => {
    try {
        return (thisString === null || thisString.trim() === "");
    }
    catch (e) {
        return true;
    }
};

export const isValidEmail = (thisEmail) => {
    try {
        thisEmail = thisEmail || "";
        const regex = /(.+)@(.+){2,}\.(.+){2,}/;
        return regex.test(thisEmail);
    }
    catch (e) {
        return false;
    }
};

export const isValidPassword = (thisPassword) => {
    try {
        thisPassword = thisPassword || "";
        const hasCapital = (/([A-Z]+)/g.test(thisPassword)) ? true : false;
        const hasLower = (/([a-z]+)/g.test(thisPassword)) ? true : false;
        const hasSpecial = (/[!@#$ %^&* (),.? ":{}|<>/[`~|\]\\0-9]/g.test(thisPassword)) ? true : false;
        const hasReqLength = thisPassword.length > 7 ? true : false;
        return hasCapital && hasLower && hasSpecial && hasReqLength;
    }
    catch (e) {
        return false;
    }
};

export const isObjectEmpty = (thisObject) => {
    try {
        return Object.keys(thisObject).length === 0;
    }
    catch (e) {
        return true;
    }
};


// Caution... don't use this on big objects... the intention is for use copying nested initial state objects
export const deepCopy = (src) => {
    let target = {};
    for (let prop in src) {
        if (src.hasOwnProperty(prop)) {
            if (!isObjectEmpty(src[prop])) {
                target[prop] = deepCopy(src[prop]);
            }
            else {
                target[prop] = src[prop];
            }

        }
    }
    return target;
};


// Here is a simple wrapper function to protect your Sagas against 401s, 404s or 500s, where we might want to handle those conditions more gracefully
export const safeCall = (saga, ...args) => call(function* () {
    var oResult;
    try {
        //debugger;
        oResult = yield call(saga, ...args);
        //debugger;
        return { err: false, result: oResult };
    } catch (err) {
        // don't really want this here.  this function is designed to fail
        //debugger;
        return { err: true, result: err };
    }
});


export const dateAsUTCString = (oDate) => {
    return padLeftZeros(oDate.getUTCFullYear().toString(), 4) + "-" +
        padLeftZeros(oDate.getUTCMonth().toString() + 1, 2) + "-" +
        padLeftZeros(oDate.getUTCDate().toString(), 2) + "T" +
        padLeftZeros(oDate.getUTCHours().toString(), 2) + ":" +
        padLeftZeros(oDate.getUTCMinutes().toString(), 2) + ":" +
        padLeftZeros(oDate.getUTCSeconds().toString(), 2) + "Z";

};


export const padLeftZeros = (sString, iLen) => {
    return padLeft(sString, iLen, '0');
};


export const padLeft = (sString, iLen, sPadChar) => {
    while (sString.length < iLen) {
        sString = sPadChar + sString;
    }
    return sString;
};



export const trimComma = (sString) => {
    if (sString && sString.length > 0) {
        sString = sString.trim();
        sString = sString.replace(/(^,)|(,$)/g, "");
    }
    return sString;
};


export const lCase = (sString) => {
    if (sString) {
        sString = sString.toLowerCase();
    }
    return sString;
};


export const usersAreTheSame = (primaryUser, myChartProxyUser) => {
    try {
        if (primaryUser && !myChartProxyUser) {
            return true;
        }
        if (primaryUser && myChartProxyUser) {
            if (primaryUser.externalId === myChartProxyUser.externalId && lCase(primaryUser.myChartId) === lCase(myChartProxyUser.myChartId)) {
                return true;
            }
        }
    }
    catch (ex) {

    }
    return false;
};



export const timeformat = (date) => {
    try {
        if (date) {
            var h = date.getHours();
            var m = date.getMinutes();
            var x = h >= 12 ? 'PM' : 'AM';
            h = h % 12;
            h = h ? h : 12;
            m = m < 10 ? '0' + m : m;
            var mytime = h + ':' + m + ' ' + x;
            return mytime;
        }
    } catch (e) {
    }
}

export const calculateDateInDays = (date1, date2) => {
    try {
        var diffc = date1.getTime() - date2.getTime();
        var days = Math.round(Math.abs(diffc / (1000 * 60 * 60 * 24)));
        return days;
    }
    catch (e) {
    }
}

export const formatDate = (date) => {
    try {
        if (date) {
            var month = '' + (date.getMonth() + 1),
                day = '' + date.getDate(),
                year = date.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            month = getMonthName(month);
            return [month, day].join(' ');
        }
    } catch (e) {
        //debugger;
    }
};

export const formatDateForSafari = (date) => {
    try {
        if (date) {
            return date.replace(/-/g, '/').replace('T', ' ');
        }
    } catch (e) {
        //debugger;
    }
};

export const getRootRef = (oObject) => {
    if (oObject.getWrappedInstance) {
        return getRootRef(oObject.getWrappedInstance() || oObject);
    }
    return oObject;
};


export const toJSDate = (dateTime, dateFormat) => {
    try {
        if (dateTime) {
            if (typeof window !== 'undefined') {
                return dateFormat ? moment(dateTime, dateFormat).toDate() : moment(dateTime).toDate();
            } else {
                return new Date(dateTime);
            }
        }
    } catch (e) {
    }
}

export const getDateFormats = () => {
    return ['YYYY-MM-DD HH:mm:ss', 'YYYY-M-D HH:mm:ss', 'YYYY-MM-D HH:mm:ss', 'YYYY-M-DD HH:mm:ss'];
};


export const addMonths = (dateTime, iMonths) => {
    let momentDate = moment(dateTime);
    return momentDate.add(iMonths, 'months').toDate();
}

export const addDays = (dateTime, iDays) => {
    let momentDate = moment(dateTime);
    return momentDate.add(iDays, 'days').toDate();
}


export const dateSimpleFormat = (dateTime) => {
    let momentDate = moment(dateTime);
    return momentDate.format("YYYY-MM-DD");
}

export const getSpecificDateFormat = (dateTime) => {
    let momentDate = moment(dateTime);
    return momentDate.format("MM-DD-YYYY");
}

export const getDateStrByFormat = (dateTime, format) => {
    let momentDate = moment(dateTime);
    return momentDate.format(format ? format : "YYYY-MM-DD");
}

export const getMonthFullName = (monthValue, format) => {
    try {
        if (monthValue) {
            if (typeof window !== 'undefined') {
                return format ? moment(monthValue, 'MM').format(format) : moment(monthValue, 'MM').format('MMMM');
            }
        }
        return ""
    } catch (e) {
        return "";
    }
};

export const getMonthName = (month) => {
    switch (month) {
        case "01":
            return "JAN";
            break;
        case "02":
            return "FEB";
            break;
        case "03":
            return "MAR";
            break;
        case "04":
            return "APR";
            break;
        case "05":
            return "MAY";
            break;
        case "06":
            return "JUN";
            break;
        case "07":
            return "JUL";
            break;
        case "08":
            return "AUG";
            break;
        case "09":
            return "SEP";
            break;
        case "10":
            return "OCT";
            break;
        case "11":
            return "NOV";
            break;
        case "12":
            return "DEC";
            break;
        default:
            return "";
            break;
    }
}

export const isDateAfter = (date, compareToDate) => {
    return moment(date).isAfter(compareToDate);
}

export const formatTimeString = (timeString) => {
    let ret = "";

    if (timeString.indexOf(":") > 0) {
        let parts = timeString.split(":");
        let hours = parseInt(parts[0]);
        let AMPM = hours < 12 ? "AM" : "PM";
        hours = hours > 12 ? hours - 12 : hours;
        let minutes = parts[1].toString().padStart(2, "0");
        ret = `${hours}:${minutes} ${AMPM}`;
    }

    return ret;
}


//let isBlocked = false;

//export const block = (historyObject, prompt = false) => {
//    debugger;

//    let historyScope = historyObject.listen["[[Scopes]]"];
//    debugger;
//    const unblock = historyScope[0].transitionManager.setPrompt(prompt);

//    if (!isBlocked) {
//        historyScope[0].checkDOMListeners(1);
//        isBlocked = true;
//    }

//    return () => {
//        if (this.isBlocked) {
//            this.isBlocked = false;
//            historyScope[0].checkDOMListeners(-1);
//        }

//        return unblock();
//    };
//}

export const getStates = () => {
    return [
        { value: 'AL', label: 'Alabama' },
        { value: 'AK', label: 'Alaska' },
        { value: 'AZ', label: 'Arizona' },
        { value: 'AR', label: 'Arkansas' },
        { value: 'CA', label: 'California' },
        { value: 'CO', label: 'Colorado' },
        { value: 'CT', label: 'Connecticut' },
        { value: 'DE', label: 'Delaware' },
        { value: 'FL', label: 'Florida' },
        { value: 'GA', label: 'Georgia' },
        { value: 'HI', label: 'Hawaii' },
        { value: 'ID', label: 'Idaho' },
        { value: 'IL', label: 'Illinois' },
        { value: 'IN', label: 'Indiana' },
        { value: 'IA', label: 'Iowa' },
        { value: 'KS', label: 'Kansas' },
        { value: 'KY', label: 'Kentucky' },
        { value: 'LA', label: 'Louisiana' },
        { value: 'ME', label: 'Maine' },
        { value: 'MD', label: 'Maryland' },
        { value: 'MA', label: 'Massachusetts' },
        { value: 'MI', label: 'Michigan' },
        { value: 'MN', label: 'Minnesota' },
        { value: 'MS', label: 'Mississippi' },
        { value: 'MO', label: 'Missouri' },
        { value: 'MT', label: 'Montana' },
        { value: 'NE', label: 'Nebraska' },
        { value: 'NV', label: 'Nevada' },
        { value: 'NH', label: 'New Hampshire' },
        { value: 'NJ', label: 'New Jersey' },
        { value: 'NM', label: 'New Mexico' },
        { value: 'NY', label: 'New York' },
        { value: 'NC', label: 'North Carolina' },
        { value: 'ND', label: 'North Dakota' },
        { value: 'OH', label: 'Ohio' },
        { value: 'OK', label: 'Oklahoma' },
        { value: 'OR', label: 'Oregon' },
        { value: 'PA', label: 'Pennsylvania' },
        { value: 'RI', label: 'Rhode Island' },
        { value: 'SC', label: 'South Carolina' },
        { value: 'SD', label: 'South Dakota' },
        { value: 'TN', label: 'Tennessee' },
        { value: 'TX', label: 'Texas' },
        { value: 'UT', label: 'Utah' },
        { value: 'VT', label: 'Vermont' },
        { value: 'VA', label: 'Virginia' },
        { value: 'WA', label: 'Washington' },
        { value: 'WV', label: 'West Virginia' },
        { value: 'WI', label: 'Wisconsin' },
        { value: 'WY', label: 'Wyoming' },
        { value: 'AS', label: 'American Samoa' },
        { value: 'DC', label: 'District of Columbia' },
        { value: 'FM', label: 'Federated States of Micronesia' },
        { value: 'GU', label: 'Guam' },
        { value: 'MH', label: 'Marshall Islands' },
        { value: 'MP', label: 'Northern Mariana Islands' },
        { value: 'PW', label: 'Palau' },
        { value: 'PR', label: 'Puerto Rico' },
        { value: 'VI', label: 'Virgin Islands' }
    ];
};

export const getACOs = () => {
    return [
        { id: 'AEBH', label: 'Aetna' },
        { id: 'AEFI', label: 'Aetna' },
        { id: 'AEMA', label: 'Aetna' },
        { id: 'AESI', label: 'Aetna' },
        { id: 'BCBS', label: 'Blue Cross Blue Shield' },
        { id: 'BCDT', label: 'Blue Cross Blue Shield' },
        { id: 'CGCT', label: 'Cigna' },
        { id: 'CGNT', label: 'Cigna' },
        { id: 'DART', label: 'Healthscope' },
        { id: 'HUMA', label: 'Humana' },
        { id: 'MSSP', label: 'Medicare' },
        { id: 'UHAC', label: 'UnitedHealth' }
    ];
};

export const isSafari = () => {
    let userAgent = (typeof navigator !== 'undefined' && navigator.userAgent) ? navigator.userAgent : "";
    let isSafari = (userAgent && !(/CriOS/i.test(userAgent)) && !(/FxiOS/i.test(userAgent)) && /^((?!chrome|android).)*safari/i.test(userAgent)) ? true : false;
    return isSafari;
};

export const getSafariBroswerVersion = (isSafari) => {
    let version = 0;
    try {
        if (isSafari && typeof navigator !== 'undefined' && navigator.appVersion) {
            let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (ua && !ua.indexOf("Chrome") > -1) {
                if (/trident/i.test(M[1])) {
                    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return { name: 'IE', version: (tem[1] || '') };
                }
                if (M[1] === 'Chrome') {
                    tem = ua.match(/\bOPR|Edge\/(\d+)/);
                    if (tem !== null) { return { name: 'Opera', version: tem[1] }; }
                }
                M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                if ((tem = ua.match(/version\/(\d+)/i)) !== null) { M.splice(1, 1, tem[1]); }
                version = M[1];
            }
        }
    } catch (err) {
        console.log(err);
    }
    return version;
};

export const getBroswerVersion = () => {
    let version = 0;
    try {
        if (typeof navigator !== 'undefined' && navigator.appVersion) {
            let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return { name: 'IE', version: (tem[1] || '') };
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\bOPR|Edge\/(\d+)/);
                if (tem !== null) { return { name: 'Opera', version: tem[1] }; }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) !== null) { M.splice(1, 1, tem[1]); }
            version = M[1];
        }
    } catch (err) {
        console.log(err);
    }
    return version;
};

export const dateStringFormat = (dateTime, formatStr) => {
    if (typeof window !== 'undefined' && dateTime) {
        let momentDate = moment(dateTime);
        let fmtStr = formatStr ? formatStr : "YYYY-MM-DD";
        return momentDate.format(fmtStr);
    }
    return;
};

export const validateManualDate = (dateTime, formatStr) => {
    if (typeof window !== 'undefined' && dateTime) {
        let isValid = moment(dateTime, formatStr, true).isValid();
        return isValid;
    }
    return false;
};

export const isMobileQuery = (location) => {
    if (typeof location !== 'undefined' && location) {
        const params = queryString.parse(location.search);
        if (params && params.mobile === 'true') {
            return true;
        }
        else {
            let isMobileUrl = typeof window !== 'undefined' && window.location && window.location.href.indexOf('mobile=true') > 0 ? true : false;
            return isMobileUrl;
        }
    }
    return false;
};

export const isMobileQueryDisabled = (location) => {
    if (typeof location !== 'undefined' && location) {
        const params = queryString.parse(location.search);
        if (params && params.mobile === 'false') {
            return true;
        }
        else {
            let isMobileUrl = typeof window !== 'undefined' && window.location && window.location.href.indexOf('mobile=false') > 0 ? true : false;
            return isMobileUrl;
        }
    }
    return false;
};

export const isRegistrationQuery = (location) => { //created seperate fof like the above isMobileQuery
    if (typeof location !== 'undefined' && location) {
        const params = queryString.parse(location.search);
        if (params && params.registration === 'true') {
            return true;
        }
    }
    return false;
};

export const isNewerVersion = (oldVer, newVer) => {
    if (oldVer && newVer) {
        const oldParts = oldVer.split('.');
        const newParts = newVer.split('.');
        for (var i = 0; i < newParts.length; i++) {
            const a = parseInt(newParts[i]) || 0;
            const b = parseInt(oldParts[i]) || 0;
            if (a > b) return true;
            if (a < b) return false;
        }
    }
    return false;
};

export const setFocus = (inputId, condition) => {
    if (typeof condition === 'undefined' || condition) {
        const input = document.querySelector('#' + inputId);
        if (input) {
            input.focus();
        }
    }
};

export const setItemToSessionStorage = (key, valueToSet) => {
    if (window && window.sessionStorage) {
        const value = window.sessionStorage.getItem(key);
        if (value === null || value !== valueToSet)
            window.sessionStorage.setItem(key, valueToSet);
    }
};

export const getItemFromSessionStorage = (key) => {
    if (window && window.sessionStorage)
        return window.sessionStorage.getItem(key);
};

export const clearItemFromSessionStorage = (key) => {
    if (window && window.sessionStorage)
        window.sessionStorage.removeItem(key);
};

export const clearItemFromSessionStorageWithStrContains = (key) => {
    if (window && window.sessionStorage && key) {
        for (let skey in window.sessionStorage) {
            if (window.sessionStorage.hasOwnProperty(skey) && skey && skey.indexOf(key) > -1) {
                window.sessionStorage.removeItem(skey);
            }
        }
    }
};

export const buildUrl = (domainRoot, urlPath, queryParams) => {
    if (domainRoot.charAt(domainRoot.length - 1) !== "/") {
        domainRoot = domainRoot + "/";
    }
    if (urlPath.charAt(0) === "/") {
        urlPath = urlPath.substring(1);
    }
    var workUrl = domainRoot + urlPath;
    if (queryParams && queryParams.length > 0) {
        queryParams.forEach((parm, index) => {
            if (parm.key) {
                if (workUrl.toLowerCase().indexOf(parm.key.toLowerCase()) == -1) {
                    if (workUrl.indexOf("?") == -1) {
                        workUrl += "?";
                    }
                    else {
                        workUrl += "&";
                    }
                    workUrl += parm.key + "=" + encodeURIComponent(parm.value);
                }
            }
        });
    }
    return workUrl;
}

export const isBrowserIEOrEdge = () => {
    if (typeof navigator !== 'undefined' && /MSIE|Trident|Edge/i.test(navigator.userAgent))
        return true;
    return false;
};

export const linkPhoneNumber = (stringWithPhoneNumber) => {
    const regex = /.*(\d{3}\.\d{3}\.\d{4}).*/;
    const matchedPhoneNumber = stringWithPhoneNumber.match(regex) && stringWithPhoneNumber.match(regex)[1];
    const linkedPhoneNumber = `<a href="tel:${matchedPhoneNumber}">${matchedPhoneNumber}</a>`;
    if (matchedPhoneNumber)
        stringWithPhoneNumber = stringWithPhoneNumber.replace(matchedPhoneNumber, linkedPhoneNumber);
    return stringWithPhoneNumber;
};

export const fileToBase64 = (file) => {
    return new Promise(resolve => {
        var reader = new FileReader();
        // Read file content on file loaded event
        reader.onload = function (event) {
            const base64String = event.target.result.replace("data:", "").replace(/^.+,/, ""); // remove data url part
            resolve(base64String);
        };
        // Convert data to base64 
        reader.readAsDataURL(file);
    });
};

export const formatRxErrorMessage = (action) => {
    let errorMsg = null;
    if (action && action.error) {
        if (action.error.status) {
            switch (action.error.status) {
                case 409: errorMsg = "The request may have already been approved or declined."; break;
                default: errorMsg = "We're sorry, we currently are unable to process this request."; break;
            }
        }
        else {
            errorMsg = (typeof action.error === "string") ? action.error : null;
        }
    }
    return errorMsg;
};

export const getTimeZone = (dateInput) => {
    var dateObject = dateInput || new Date(),
        dateString = dateObject + "",
        tzAbbr = (
            dateString.match(/\(([^\)]+)\)$/) || dateString.match(/([A-Z]+) [\d]{4}$/)
        );
    if (tzAbbr) {
        tzAbbr = tzAbbr[1].match(/[A-Z]/g).join("");
    }
    return tzAbbr;
};

export const findInternalId = (IdsArray) => {
    const internalId = IdsArray && IdsArray.reduce(function (prevValue, currValue) {
        return (currValue && currValue.idType && currValue.idType.toLowerCase() === "internal") ? currValue.id.trim() : prevValue;
    }, null);
    return internalId;
};


export const browserDetection = () => {
    if (typeof navigator !== 'undefined' && navigator && navigator.userAgent) {
        if (/Edge\/\d./i.test(navigator.userAgent)) {
            return "Edge";
        } else if (/MSIE|Trident/i.test(navigator.userAgent)) {
            return "IE";
        } else if (navigator.userAgent.indexOf("Firefox") > -1) {
            return 'Firefox';
        } else if (navigator.userAgent.indexOf("CriOS") > -1) { //Mobile IOS Chrome
            return 'Chrome'
        } else if (navigator.userAgent.indexOf("FxiOS") > -1) { //Mobile IOS Firefox
            return 'Firefox';
        } else if (navigator.userAgent.indexOf("edg") > -1) {
            return 'New Edge';
        } else if ((navigator.userAgent.indexOf("Opera") > -1) || (navigator.userAgent.indexOf("OPR") > -1)) {
            return 'Opera';
        } else if (navigator.userAgent.indexOf("SamsungBrowser") > -1) {
            return 'Samsung Internet';
        } else if ((navigator.userAgent.indexOf('Mozilla/5.0') > -1 && navigator.userAgent.indexOf('Android ') > -1 &&
            navigator.userAgent.indexOf('AppleWebKit') > -1) && (navigator.userAgent.indexOf('Version') > -1)) {
            return 'Android Native'; //Mobile Android default browser
        } else if (!(navigator.userAgent.indexOf("Chrome") > -1) && (navigator.userAgent.indexOf("Safari") > -1)) {
            return 'Safari';
        } else if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.vendor && /Google Inc/.test(navigator.vendor)) {
            return 'Chrome';
        }
    }
    return '';
};

//Get current Date In Central Time Zone.
export const getCurDateInCentralTz = () => {
    try {
        return moment.tz(moment(), CENTRAL_TIME_ZONE);
    }
    catch (error) {
        return new Date();
    }
};

//Get convert Date In Central Time Zone.
export const convertDateToCentralTz = (dateString) => {
    try {
        return moment.tz(dateString, CENTRAL_TIME_ZONE);
    }
    catch (error) {
        return new Date(dateString);
    }
};


//Compare date
export const isSameDate = (srcDateString, desDateString) => {
    try {
        return moment(srcDateString).isSame(desDateString);
    }
    catch (error) {
        return false;
    }
};


//Get Difference in days by Central Time Zone.
export const differenceInDays = (dateString) => {
    try {
        const visitDate = convertDateToCentralTz(dateString);
        const visitDateMinusTime = visitDate.clone().hour(0).minute(0).second(0).millisecond(0);
        const now = getCurDateInCentralTz();
        const nowMinusTime = now.clone().hour(0).minute(0).second(0).millisecond(0);
        return visitDateMinusTime.diff(nowMinusTime, 'days');
    }
    catch (error) {
        const date1 = toJSDate(dateString);
        date1.setHours(0, 0, 0, 0);
        const currDate = new Date();
        currDate.setHours(0, 0, 0, 0);
        return calculateDateInDays(date1, currDate);
    }
};

//Get CST Time Format.
export const getCentralDateWithFormat = (dateString, format) => {
    return convertDateToCentralTz(dateString).format(format);
};

//Helpers functions to use in Video Visits.
export const subtractMinutesFromDate = (dateString, minutes) => {
    try {
        const date = convertDateToCentralTz(dateString);
        return date.clone().subtract(minutes, "minutes");
    }
    catch (error) {
        const date = new Date(formatDateForSafari(dateString));
        date.setMinutes(timeBefore.getMinutes() - minutes);
        return date;
    }
};

export const addMinutesToDate = (dateString, minutes) => {
    try {
        const date = convertDateToCentralTz(dateString);
        return date.clone().add(minutes, "minutes");
    }
    catch (error) {
        const date = new Date(formatDateForSafari(dateString));
        date.setMinutes(timeBefore.getMinutes() + minutes);
        return date;
    }
};

export const isVisitToday = (dateString) => {
    const now = getCurDateInCentralTz();
    const visitDate = convertDateToCentralTz(dateString);
    const yearInNow = now && (now.year ? now.year() : now.getFullYear ? now.getFullYear() : null);
    const yearInVisitDate = visitDate && (visitDate.year ? visitDate.year() : visitDate.getFullYear ? visitDate.getFullYear() : null);
    const monthInNow = now && (now.month ? now.month() : now.getMonth ? now.getMonth() : null);
    const monthInVisitDate = visitDate && (visitDate.month ? visitDate.month() : visitDate.getMonth ? visitDate.getMonth() : null);
    const dateInNow = now && (now.date ? now.date() : now.getDate ? now.getDate() : null);
    const dateInVisitDate = visitDate && (visitDate.date ? visitDate.date() : visitDate.getDate ? visitDate.getDate() : null);
    return (yearInNow === yearInVisitDate && monthInNow === monthInVisitDate && dateInNow === dateInVisitDate);
};

export const formatCentralDate = (dateObj, format) => {
    return dateObj.format ? dateObj.format(format) : dateObj;
};

export const isBetween = (date1Obj, date2Obj) => {
    if (!date1Obj || !date2Obj) return false;
    const now = getCurDateInCentralTz();
    if (now.isBetween) {
        return now.isBetween(date1Obj, date2Obj);
    }
    else
        return (now >= date1Obj && now <= date2Obj);
};

export const isAfter = (dateObj) => {
    if (!dateObj) return false;
    const now = getCurDateInCentralTz();
    if (now.isAfter)
        return now.isAfter(dateObj);
    else
        return now >= dateObj;
};

export const getHealthPlanByProviderKey = (healthPlans, key) => {
    let healthPlan = null;
    try {
        for (let pIndex = 0; pIndex < healthPlans.length; pIndex++) {
            const { LoginProvider } = healthPlans[pIndex];
            if (LoginProvider && LoginProvider.toLowerCase() === key) {
                healthPlan = healthPlans[pIndex];
                break;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return healthPlan;
};

export const copyText = (text) => {
    if (!navigator.clipboard) {  //Edge browser does not support , so fallback added.
        fallbackCopyText(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
};

const fallbackCopyText = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
};

export const getFeature = (profileData, key) => {
    var oMatch;
    if (profileData && profileData.features && profileData.features.length > 0) {
        oMatch = profileData.features.find((feature) => {
            return feature.key && feature.key.toLowerCase() == key.toLowerCase();
        });
    }
    return oMatch;

}

export const getMembership = (profileData, key) => {
    var oMatch;
    if (profileData && profileData.memberships && profileData.memberships.length > 0) {
        oMatch = profileData.memberships.find((membership) => {
            return membership.membershipKey.toLowerCase() == key.toLowerCase();
        });
    }
    return oMatch;
}

export const convertProfileListToProxyList = (profileList) => {
    var newProxyList = [];

    try {
        profileList.forEach((c, index, arr) => {
            var newProxy = convertProfileToProxy(c, index);
            newProxyList.push(newProxy);
        });
    }
    catch (ex) {
        //debugger;
        console.error(ex);
    }

    //debugger;
    return newProxyList;
}

export const ageInMonths = (dob) => {
    let today = new Date(); 
    let age = null;
    if (dob) {
        //const totalmonth=moment().diff(moment(dob), 'month'); 
       // age = parseFloat(parseInt(totalmonth/12)+"."+totalmonth%12); 
  		var d = new Date(dob); 
      	var years = today.getFullYear() - d.getFullYear(); 
   		d.setFullYear(d.getFullYear() + years);
        var days = (today.getTime() - d.getTime()) / (3600 * 24 * 1000);
        let totalMonth = years + days / (isLeapYear(d.getFullYear()) ? 366 : 365);
        age = (totalMonth).toFixed(2);
      }
    
    return age;
}

const isLeapYear = (year) => {
    var d = new Date(year, 1, 28);
    d.setDate(d.getDate() + 1);
    return d.getMonth() == 1;
}

export const getContentWindow = (frame) => {
    return (frame && frame.contentWindow ? frame.contentWindow : frame);
}

export const getSessionItem = (itemName, callback) => {
    //debugger;
    var frame = window.document.getElementById("frmStorage");
    var win = getContentWindow(frame);
    var item = null;
    if (win && window.serverData.data.storageControllerV2) {
        item = win.getSessionItem(itemName);
    }
    else if (typeof self !== "undefined" && self["sessionStorage"][itemName]) {
        item = self["sessionStorage"][itemName];
    }
    if (callback) {
        callback(null, item);
    }
    if (itemName == "root") {
        // combine session and window properties
        var oItem = JSON.parse(item ? item : "{}");
        oItem["inMemory"] = window.inMemory ? window.inMemory : {};
        item = JSON.stringify(oItem);
    }
    return item;
}

export const setSessionItem = (itemName, value, callback) => {
    var frame = window.document.getElementById("frmStorage");
    var win = getContentWindow(frame);
    if (win && window.serverData.data.storageControllerV2) {
        if (itemName == "root") {
            var oValue = JSON.parse(value);
            window.inMemory = oValue["inMemory"] ? oValue["inMemory"] : "{}";
            oValue["inMemory"] = {};
            win.setSessionItem(itemName, JSON.stringify(oValue));
        }
        else {
            win.setSessionItem(itemName, value);
        }
    }
    else {
        if (typeof self !== "undefined") {
            self["sessionStorage"].setItem(itemName, value, callback)
        }
    }
    if (callback) {
        callback(null);
    }
    return null;
}

export const removeSessionItem = (itemName, callback) => {
    var frame = window.document.getElementById("frmStorage");
    var win = getContentWindow(frame);
    if (win && window.serverData.data.storageControllerV2) {
        win.removeSessionItem(itemName);
    }
    else {
        if (typeof self !== "undefined") {
            self["sessionStorage"].removeItem(itemName, callback)
        }
    }
    if (callback) {
        callback(null);
    }
    return null;

}



export const getProfileListFromMembershipData = (membershipData) => {
    var profileList = [];

    if (membershipData && membershipData.epic) {
        let oCurrMem = { patient: membershipData.epic.patient, features: membershipData.features, memberships: membershipData.memberships };
        profileList.push(oCurrMem);
        if (membershipData.epic.proxySubjects) {
            membershipData.epic.proxySubjects.forEach((c, index, arr) => {
                profileList.push(membershipData.epic.proxySubjects[index]);
            });
        }
    }

    return profileList;
}

export const convertProfileToProxy = (profileData, index) => {
    var newProxy = null;
    try {
        if (profileData && profileData.patient) {
            //debugger;
            newProxy = {
                displayName: profileData.patient.PatientName,
                externalId: getPatientID(profileData.patient.PatientIds, IDTypes.EXTERNAL),
                internalId: getPatientID(profileData.patient.PatientIds, IDTypes.INTERNAL),
                myChartId: getPatientID(profileData.patient.PatientIds, IDTypes.MYCHARTLOGIN) || profileData.patient.MyChartAccount,
                eid: getPatientID(profileData.patient.PatientIds, IDTypes.EID),
                relationshipId: profileData.patient.RelationshipID,
                ageYears: profileData.patient.AgeYears,
                dob: profileData.patient.DOB, //"DOB" key comming from API
                isMinor: profileData.patient.IsMinor,
                index: index,
                epi: getPatientID(profileData.patient.PatientIds, IDTypes.EPI),
                expireDate: profileData.patient.ToDate,

                //Comments: c.patient.Comments,
                //DeploymentDescriptor: c.patient.DeploymentDescriptor,
                //DisabledReason: c.patient.DisabledReason,
                //FromDate: c.patient.FromData,
                //MyChartStatus: c.patient.MyChartStatus,
                //PatientName: c.patient.PatientName,
                //Relation: c.patient.Relation, 
                //RelationshipID: c.patient.RelationshipID, 
                //ToDate: c.patient.ToDate,
                //PatientIds: c.patient.PatientIds, 
                //AgeYears: c.patient.AgeYears, 
                //InuranceId: null, 
                //IsMinor: c.patient.IsMinor, 
                //EID: c.patient.EID, 
                //EPID: c.patient.EPID,
                //AuthorizedFeatures: null, 
                //IsMedicaid: c.patient.IsMedicaid, 
                //LinkedAccountStatus: null,
            };
        }
        else {
            //debugger;
            console.log("Why here?");
        }
    }
    catch (EX) {
        //debugger;
        console.error(EX);
        throw EX;
    }

    return newProxy;
}

export const extractEVisitInfo = (eVisitData) => {
    return {
        subscriberVsDependent: eVisitData.EvisitInfo.EviSubscriberVsDependent,
        isZipnosisEligible: eVisitData.EvisitInfo.IsZipnosisEvistEligible,
        isMyChartEVisit: eVisitData.EvisitInfo.IsMyChartEvisit,
        bswZipGroup: eVisitData.EvisitInfo.BswZipGroup ? {
            id: eVisitData.EvisitInfo.BswZipGroup.Id,
            name: eVisitData.EvisitInfo.BswZipGroup.Name,
            price: eVisitData.EvisitInfo.BswZipGroup.Price,
        } : null
    }
}

export const hasFeature = (membershipData, key) => {
    //debugger;
    if (membershipData.features && membershipData.features.length > 0) {
        var oMatch = membershipData.features.find((feature) => { return feature.key.toLowerCase() == key.toLowerCase(); });
        if (oMatch) {
            return true;  // active flag only matters for insurance things
        }
    }
    return false;
}

export const hasMyChart = (membershipData) => {
    return (membershipData.epic && membershipData.epic.patient ? membershipData.epic.patient.HasMyChartAccount : false);
}

export const getMyChartID = (membershipData) => {
    return (membershipData.epic && membershipData.epic.patient ? membershipData.epic.patient.MyChartAccount : null);
}

export const getMemberDataPatientID = (membershipData, idType) => {
    return getPatientID(membershipData.epic.patient.PatientIds, idType);
}

export const getPatientID = (PatientIDs, idType) => {
    //debugger;
    var sRet = null;
    try {
        if (!PatientIDs) return null;
        for (var i = 0; i < PatientIDs.length; i++) {
            var currentValue = PatientIDs[i];
            if (currentValue.IDType.toUpperCase() === idType.toUpperCase()) {
                sRet = currentValue.ID;
                break;
            }
        }
    }
    catch (E) {
        //debugger;
        console.error(E);
    }
    return sRet;
}



const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

// Detect our time zone is Central Time Zone or not.
export const isCentralTimeZone = () => moment.tz.guess() === CENTRAL_TIME_ZONE;

// Sort conversations in descending order By lastMessageNoteDate
export const sortConversations = (conversations) => {
    let conversationList = conversations && conversations.conversations ? conversations.conversations : [];
    if (conversationList && conversationList.length > 0) {
        conversationList = [].concat(conversationList).sort((conversationA, conversationB) => {
            const dateA = conversationA.lastMessageNoteDate;
            const dateB = conversationB.lastMessageNoteDate;
            return dateA > dateB ? -1 : 1;
        });
    }

    return conversationList;
}

export const sortMessages = (messages) => {
    let messagesList = messages && messages.messages ? messages.messages : [];
    if (messagesList && messagesList.length > 0) {
        messagesList = [].concat(messagesList).sort((messageA, messageB) => {
            const dateA = messageA.noteDate;
            const dateB = messageB.noteDate;
            return dateA > dateB ? -1 : 1;
        });
    }
    return { ...messages, messages: messagesList.reverse() };
}
export const getQueryStringValue = (qs, param) => {
    let val = "";
    let reg = new RegExp('[?&]' + param + '=([^&#]*)', 'i');
    if (qs.indexOf(param) != -1) {
        val = reg.exec(qs)[1];
        //console.info(qs);
    }
    console.info(`Tools.getQueryStringValue param '${param}' value '${val}' `, qs);
    return val;
}

// Reference : https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
export const getOSInfo = () => {
    var unknown = 'Unknown';
    //browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;

    // system
    var os = unknown;
    var clientStrings = [
        { s: 'Windows 3.11', r: /Win16/ },
        { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
        { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
        { s: 'Windows 98', r: /(Windows 98|Win98)/ },
        { s: 'Windows CE', r: /Windows CE/ },
        { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
        { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
        { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
        { s: 'Windows Vista', r: /Windows NT 6.0/ },
        { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
        { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
        { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
        { s: 'Windows ME', r: /Windows ME/ },
        { s: 'Android', r: /Android/ },
        { s: 'Open BSD', r: /OpenBSD/ },
        { s: 'Sun OS', r: /SunOS/ },
        { s: 'Linux', r: /(Linux|X11)/ },
        { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
        { s: 'Mac OS X', r: /Mac OS X/ },
        { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: 'QNX', r: /QNX/ },
        { s: 'UNIX', r: /UNIX/ },
        { s: 'BeOS', r: /BeOS/ },
        { s: 'OS/2', r: /OS\/2/ },
        { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = unknown;

    try {
        if (/Windows/.test(os)) {
            osVersion = /Windows (.*)/.exec(os);
            if (osVersion)
                osVersion = osVersion[1] || 0;
            os = 'Windows';
        }

        switch (os) {
            case 'Mac OS X':
                osVersion = /Mac OS X (\d+)_(\d+)_?(\d+)?/.exec(nAgt);
                if (osVersion) {
                    osVersion = `${osVersion[1] || 0}.${osVersion[2] || 0}.${osVersion[3] || 0}`;
                };
                break;

            case 'Android':
                osVersion = /Android ([\.\_\d]+)/.exec(nAgt);
                if (osVersion)
                    osVersion = osVersion[1] || 0;
                break;

            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                if (osVersion)
                    osVersion = [parseInt(osVersion[1] || 0, 10), parseInt(osVersion[2] || 0, 10), parseInt(osVersion[3] || 0, 10)];
                break;
        }

        return {
            os: os,
            osVersion: osVersion
        };
    }

    catch (error) {
        return { os: "", osVersion: "" };
    }
}

export const getEndOfMonth = (year, month) => {
    let dt = new Date();
    if (year) {
        dt = new Date(year, month + 1, 0);
    }
    return dt;
};


export const getStartOfMonth = (year, month) => {
    let dt = new Date();
    if (year) {
        dt = new Date(year, month, 1);
    }
    return dt;
};

// Get Month number from DateString
// firefox , Crome & other browser Support 

export const getMonthNumber = (dateString) => {
    if (dateString) {
        const dateData = dateString.split(' ');
        const month = dateData[0].substring(0, 3).toUpperCase();
        switch (month) {
            case "JAN": return "1";
            case "FEB": return "2";
            case "MAR": return "3";
            case "APR": return "4";
            case "MAY": return "5";
            case "JUN": return "6";
            case "JUL": return "7";
            case "AUG": return "8";
            case "SEP": return "9";
            case "OCT": return "10";
            case "NOV": return "11";
            case "DEC": return "12";
        }
    }
};

// Scroll element into window view not scrolling within another element
// Using scrollTo instead of scrollIntoView for better Safari support
export const scrollIntoWindowView = (id, el, behavior, offSet) => {
    let element = document.querySelector(id) || el;
    let animateBehavior = behavior ? behavior : "smooth";
    const topOffset = offSet ? offSet : -90;

    if (element && window) {
        const scrollY = element.getBoundingClientRect().top + window.pageYOffset + topOffset;
        window.scrollTo({ top: scrollY, behavior: animateBehavior });
    }
}

//Check string is json.
export const IsJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}


export const IncrementInstanceCount = () => {
    try {
        var sLastInstCnt = localStorage.getItem("lastinstcnt");
        var dLastInstCnt;
        if (sLastInstCnt) {
            dLastInstCnt = Date.parse(sLastInstCnt);
        }
        else {
            dLastInstCnt = new Date();
        }

        var sInstCnt = localStorage.getItem("instcnt");
        var iInstCnt;
        if (sInstCnt) {
            iInstCnt = parseFloat(sInstCnt);
        }
        else {
            iInstCnt = 0
        }
        if (iInstCnt > 100) {
            iInstCnt = 0;
        }
        var dNew = new Date();
        if (((dNew - dLastInstCnt) / 60000) > 20) {
            // debugger;
            iInstCnt = 0;
        }

        localStorage.setItem("instcnt", iInstCnt + 1);

    }
    catch (e) {

    }
}

export const DecrementInstanceCount = () => {
    try {
        //debugger;
        var sInstCnt = localStorage.getItem("instcnt");
        var iInstCnt;
        if (sInstCnt) {
            iInstCnt = parseFloat(sInstCnt);
        }
        else {
            iInstCnt = 0
        }
        iInstCnt = iInstCnt - 1;
        if (iInstCnt < 0) { iInstCnt = 0; }
        localStorage.setItem("instcnt", iInstCnt);
        localStorage.setItem("lastinstcnt", new Date());
        if (iInstCnt == 0) {
            localStorage.removeItem("root"); // this clears the left over token
        }
    }
    catch (E3) {
    }

}

export const getMonths = () => {
    return [
        { value: '01', label: 'January' },
        { value: '02', label: 'February' },
        { value: '03', label: 'March' },
        { value: '04', label: 'April' },
        { value: '05', label: 'May' },
        { value: '06', label: 'June' },
        { value: '07', label: 'July' },
        { value: '08', label: 'August' },
        { value: '09', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' }
    ];
};

export const getPreviousYears = (numberOfYears) => {
    const currentYear = (new Date()).getFullYear();
    const allYears = Array.from(new Array(numberOfYears), (val, index) => currentYear - index);
    return (
        allYears.map((yr, i) => {
            return <option key={i} value={yr}>
                {yr}
            </option>
        })
    )
};


export const getYears = () => {   
    const currentYear = (new Date()).getFullYear();
    const allYears = Array.from(new Array(5), (val, index) => currentYear - index);
    let yearsArray = allYears.map((item, index) => ({ value: '' + item, label: '' + item }));    
    return yearsArray;
};

export const getFullMonthName = (month) => {
    switch (month) {
        case "01":
            return "January";
            break;
        case "02":
            return "February";
            break;
        case "03":
            return "March";
            break;
        case "04":
            return "April";
            break;
        case "05":
            return "May";
            break;
        case "06":
            return "June";
            break;
        case "07":
            return "July";
            break;
        case "08":
            return "August";
            break;
        case "09":
            return "September";
            break;
        case "10":
            return "October";
            break;
        case "11":
            return "November";
            break;
        case "12":
            return "December";
            break;
        default:
            return "";
            break;
    }
}